import {database} from '..';
import {BUSINESS_SCHEMA, CUSTOMER_SCHEMA, ORDER_SCHEMA} from '../schema';
import {Q} from '@nozbe/watermelondb';

const order = database.collections.get(ORDER_SCHEMA);

export const observeActiveOrder = () =>
    order.query(Q.on(BUSINESS_SCHEMA, 'id', localStorage.getItem('business_id')), Q.where('status', 'active')).observeWithColumns(['redeemed_points', 'status']);

export const observeGetOrderById = id =>
    order.query(Q.on(BUSINESS_SCHEMA, 'id', localStorage.getItem('business_id')), Q.where('number', id)).observeWithColumns(['redeemed_points', 'status']);

export const fetchOrderByNum = num => order.query(Q.on(BUSINESS_SCHEMA, 'id', localStorage.getItem('business_id')), Q.where('number', num)).fetch();

export const observeCockpitActiveOrders = () =>
    order
        .query(
            Q.on(BUSINESS_SCHEMA, 'id', localStorage.getItem('business_id')),
            Q.and(Q.where('status', Q.notEq('active')), Q.where('status', Q.notEq('complete')), Q.where('status', Q.notEq('void')), Q.where('status', Q.notEq('hold'))),
            Q.sortBy('started_at', Q.desc),
        )
        .observeWithColumns(['status']);

export const fetchCompletedOrders = async (start, end, locationId) =>
    await order
        .query(
            Q.on(BUSINESS_SCHEMA, 'id', locationId || localStorage.getItem('business_id')),
            Q.where('status', 'complete'),
            Q.where('completed_at', Q.between(Number(start), Number(end))),
        )
        .fetch();
export const fetchOrdersByDate = async (start, end, locationId) =>
    await order.query(Q.on(BUSINESS_SCHEMA, 'id', locationId || localStorage.getItem('business_id')), Q.where('completed_at', Q.between(Number(start), Number(end)))).fetch();
export const fetchOrdersByCustomer = async id => await order.query(Q.on(CUSTOMER_SCHEMA, [Q.where('id', id)]), Q.where('status', 'complete')).fetch();

export const observeCompleteOrders = () =>
    order
        .query(Q.on(BUSINESS_SCHEMA, 'id', localStorage.getItem('business_id')), Q.sortBy('started_at', Q.desc))
        .observeWithColumns(['type', 'floor_plan', 'dine_in_table', 'no_of_guests']);

export const observeHeldOrderCount = () => handleHeldOrders().fetchCount();

export const observeHeldOrders = () => handleHeldOrders().observe();

const handleHeldOrders = () => order.query(Q.on(BUSINESS_SCHEMA, 'id', localStorage.getItem('business_id')), Q.where('status', 'hold'), Q.where('archive', Q.notEq(true)));

export const searchOrders = async (searchTerm, business) =>
    order
        .query(
            Q.experimentalJoinTables([CUSTOMER_SCHEMA]),
            Q.on(BUSINESS_SCHEMA, 'id', business.id),
            Q.or(
                Q.on(CUSTOMER_SCHEMA, Q.where('name', Q.like(`%${Q.sanitizeLikeString(searchTerm)}%`))),
                Q.where('number', Q.like(`%${Q.sanitizeLikeString(searchTerm)}%`)),
                Q.where('total', Q.like(`%${Q.sanitizeLikeString(searchTerm)}%`)),
            ),
        )
        .fetch();

export const getFilteredOrders = async (business_id, payment_method, status, date, name_sort, price_sort) => {
    let filterQuery = [];

    if (date?.start || date?.end) filterQuery.push(Q.where('started_at', Q.between(Number(date?.start), Number(date?.end))));
    if (payment_method != 'all') filterQuery.push(Q.where('payment_method', payment_method));

    if (name_sort) filterQuery.push(Q.sortBy('number', name_sort == 'asc' ? Q.asc : Q.desc));
    if (price_sort) filterQuery.push(Q.sortBy('total', price_sort == 'asc' ? Q.asc : Q.desc));

    if (status != 'all') filterQuery.push(Q.where('status', status));

    return await order.query(Q.on(BUSINESS_SCHEMA, 'id', business_id), ...filterQuery).fetch();
};
